




























import newButton from '@/components/Reusable/NewButton.vue';
import companies from '@/components/Company/companies.vue';
import companyType from '@/store/types/company';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'Company',
  components: {
    newButton,
    companies,
  },
  methods: {
    ...mapActions({
      CompanyList: `companyModule/${companyType.actions.COMPANY_LIST}`,
    }),
  },
  computed: {
    ...mapGetters({
      getCompanyList: `companyModule/${companyType.getters.GET_COMPANY}`,
    }),
  },
});
